import _ from 'lodash';
import moment from 'moment';
import { MyXLSX2 } from '@/utils/xlsxExport2';
import {
    paymentType, paymentStatus, serviceTypeList, attachmentTypes,
} from '@/assets/commonData/options';

let CD;
const PAY_WAY_LIST = ['零用現金', '銀行轉帳', '銀行提現'];

function getServiceTypeTxt(serviceTypeNum) {
    const s = serviceTypeList.find((x) => x.value === serviceTypeNum);
    if (s) return s.label;
    return '--';
}

export default {
    created() {
        CD = moment().format('YYYY-MM-DD');
    },
    methods: {
        async onExport(isAccountingPayed) {
            const wb = MyXLSX2.createBook();
            this.isLoadingExport = true;

            try {
                const details = this.selectedDatas.length > 0
                    ? await this.getExportDataBySelected()
                    : await this.getExportData({
                        ...this.OrderParam,
                        ...this.prevQuery,
                    });

                const toBeAuditSheet = this.getBeforePaySheet(details, '待審核', 1);
                const toBePaySheet = this.getToBePaySheet(details, '待付款', 5);
                const toBeConfirmSheet = isAccountingPayed ? this.getAfterPaySheetForAccounting(details, '待確認付款', 2) : this.getAfterPaySheet(details, '待確認付款', 2);
                const completeSheet = isAccountingPayed ? this.getAfterPaySheetForAccounting(details, '完成', 3) : this.getAfterPaySheet(details, '完成', 3);
                const rejectSheet = this.getRejectedSheet(details, '退件', 4);

                if (toBeAuditSheet) MyXLSX2.bookAppendSheet(wb, toBeAuditSheet, '待審核');
                if (toBePaySheet) MyXLSX2.bookAppendSheet(wb, toBePaySheet, '待付款');
                if (toBeConfirmSheet) MyXLSX2.bookAppendSheet(wb, toBeConfirmSheet, '待確認付款');
                if (completeSheet) MyXLSX2.bookAppendSheet(wb, completeSheet, '完成');
                if (rejectSheet) MyXLSX2.bookAppendSheet(wb, rejectSheet, '退件');

                const fileSheet = this.getFileSheet(details);
                if (fileSheet) MyXLSX2.bookAppendSheet(wb, fileSheet, '檢附單據');

                MyXLSX2.download(wb, `請款單${CD}`);
            } catch (e) {
                this.$message({
                    showClose: true,
                    message: '無資料可匯出',
                    type: 'error',
                });
            } finally {
                this.isLoadingExport = false;
            }
        },

        getBeforePaySheet(oriDetails, subTitle, status) {
            const details = _.filter(oriDetails, ['sigN_STS', status]);
            if (!details.length) return null;
            const title = `請款單 - ${subTitle}`;

            // 內容表頭
            const bodyHeader = [
                { text: '', width: 5, align: 'center' },
                { text: '單號', align: 'center' },
                { text: '摘要', width: 30, align: 'left' },
                { text: '請款單日期', align: 'center' },
                { text: '狀態', align: 'center' },
                { text: '專案編號', align: 'center' },
                { text: '專案名稱', width: 20, align: 'left' },
                { text: '類型', align: 'center' },
                { text: '申請日期', align: 'center' },
                { text: '申請人', align: 'center' },
                { text: '預計付款日', align: 'center' },
                { text: '請款金額', align: 'right', number: true },
                { text: '幣別', align: 'center' },
                { text: '匯率', width: 10, align: 'right' },
                { text: '收款戶名', align: 'center' },
                { text: '收款銀行', width: 30, align: 'center' },
                { text: '收款銀行代碼', width: 15, align: 'left' },
                { text: '收款分行代碼', width: 15, align: 'left' },
                { text: '收款銀行帳號', width: 15, align: 'left' },
            ];

            // 內容資料
            const bodyRows = [];
            details.forEach((item) => {
                const row = [
                    '',
                    item.payoo,
                    item.nam,
                    item.dat ? moment(item.dat).format('YYYY-MM-DD') : '--',
                    _.find(paymentStatus, ['key', item.sigN_STS])?.value,
                    item.poo || '--',
                    item.projectName || '--',
                    _.find(paymentType, ['key', item.typ])?.value,
                    item.crT_DAT ? moment(item.crT_DAT).format('YYYY-MM-DD') : '--',
                    item.creator,
                    item.pdat ? moment(item.pdat).format('YYYY-MM-DD') : '--',
                    item.amt,
                    item.cny,
                    this.getCnyRat(item.cny),
                    item.useR_PAY_WAY === 2 ? item.vdR_BNK_TPC : '',
                    item.useR_PAY_WAY === 2 ? item.bankName || '--' : '',
                    item.useR_PAY_WAY === 2 ? item.vdR_BNK_BOO || '--' : '',
                    item.useR_PAY_WAY === 2 ? this.getBnkDoo(item.vdR_BNK_DOO) || '--' : '',
                    item.useR_PAY_WAY === 2 ? item.vdR_BNK_ACC || '--' : '',
                ];
                bodyRows.push(row);
            });
            // 總計列
            const totalAmt = _.sumBy(details, (o) => o.amt * this.getCnyRat(o.cny));
            bodyRows.push(['', '總計(約當台幣)', '', '', '', '', '', '', '', '', '', totalAmt, '', '', '', '', '', '', '']);

            // 表頭資訊
            const headRows = [...this.getQueryText(), { label: '請款金額總計(約當台幣)', value: totalAmt }, { label: '製表日期', value: CD }];

            return MyXLSX2.createSheet(title, headRows, bodyHeader, bodyRows);
        },

        getRejectedSheet(oriDetails, subTitle, status) {
            const details = _.filter(oriDetails, ['sigN_STS', status]);
            if (!details.length) return null;
            const title = `請款單 - ${subTitle}`;

            // 內容表頭
            const bodyHeader = [
                { text: '', width: 5, align: 'center' },
                { text: '單號', align: 'center' },
                { text: '摘要', width: 30, align: 'left' },
                { text: '請款單日期', align: 'center' },
                { text: '狀態', align: 'center' },
                { text: '專案編號', align: 'center' },
                { text: '專案名稱', width: 20, align: 'left' },
                { text: '退件人', align: 'center' },
                { text: '退件日期', align: 'center' },
                { text: '退件原因', width: 20, align: 'left' },
                { text: '類型', align: 'center' },
                { text: '申請日期', align: 'center' },
                { text: '申請人', align: 'center' },
                { text: '預計付款日', align: 'center' },
                { text: '請款金額', align: 'right', number: true },
                { text: '幣別', align: 'center' },
                { text: '匯率', width: 10, align: 'right' },
                { text: '收款戶名', align: 'center' },
                { text: '收款銀行', width: 30, align: 'center' },
                { text: '收款銀行代碼', width: 15, align: 'left' },
                { text: '收款分行代碼', width: 15, align: 'left' },
                { text: '收款銀行帳號', width: 15, align: 'left' },
            ];

            // 內容資料
            const bodyRows = [];
            details.forEach((item) => {
                const row = [
                    '',
                    item.payoo,
                    item.nam,
                    item.dat ? moment(item.dat).format('YYYY-MM-DD') : '--',
                    _.find(paymentStatus, ['key', item.sigN_STS])?.value,
                    item.poo || '--',
                    item.projectName || '--',
                    _.find(item.audits, (o) => !!o.rsn)?.stF_NAM,
                    _.find(item.audits, (o) => !!o.rsn)?.sdat ? moment(_.find(item.audits, (o) => !!o.rsn)?.sdat).format('YYYY-MM-DD') : '--',
                    _.find(item.audits, (o) => !!o.rsn)?.rsn,
                    _.find(paymentType, ['key', item.typ])?.value,
                    item.crT_DAT ? moment(item.crT_DAT).format('YYYY-MM-DD') : '--',
                    item.creator,
                    item.pdat ? moment(item.pdat).format('YYYY-MM-DD') : '--',
                    item.amt,
                    item.cny,
                    this.getCnyRat(item.cny),
                    item.useR_PAY_WAY === 2 ? item.vdR_BNK_TPC : '',
                    item.useR_PAY_WAY === 2 ? item.bankName || '--' : '',
                    item.useR_PAY_WAY === 2 ? item.vdR_BNK_BOO || '--' : '',
                    item.useR_PAY_WAY === 2 ? this.getBnkDoo(item.vdR_BNK_DOO) || '--' : '',
                    item.useR_PAY_WAY === 2 ? item.vdR_BNK_ACC || '--' : '',
                ];
                bodyRows.push(row);
            });
            // 總計列
            const totalAmt = _.sumBy(details, (o) => o.amt * this.getCnyRat(o.cny));
            bodyRows.push(['', '總計(約當台幣)', '', '', '', '', '', '', '', '', '', '', '', '', totalAmt, '', '', '', '', '', '', '']);

            // 表頭資訊
            const headRows = [...this.getQueryText(), { label: '請款金額總計(約當台幣)', value: totalAmt }, { label: '製表日期', value: CD }];

            return MyXLSX2.createSheet(title, headRows, bodyHeader, bodyRows);
        },

        getFileSheet(oriDetails) {
            const details = _.flatMap(oriDetails, (o) => _.map(o.files, (x) => ({
                ...x,
                nam: o.nam,
                cny: o.cny,
                rat: o.paY_CNYRAT,
            })));

            if (!details.length) return null;
            const title = '檢附單據';

            // 內容表頭
            const bodyHeader = [
                { text: '', width: 5, align: 'center' },
                { text: '單號', align: 'center' },
                { text: '請款單摘要', width: 60, align: 'left' },
                { text: '單據類型', align: 'center' },
                { text: '單據日期', align: 'center' },
                { text: '發票號碼', align: 'left' },
                { text: '公司名稱', width: 20, align: 'left' },
                { text: '統編', width: 10, align: 'center' },
                { text: '單據總額', align: 'right', number: true },
                { text: '營業稅', align: 'right', number: true },
                { text: '銷售額(未稅)', align: 'right', number: true },
                { text: '幣別', width: 8, align: 'center' },
                { text: '匯率', width: 8, align: 'center' },
                { text: '營業稅申報', width: 20, align: 'left' },
                { text: '備註', width: 20, align: 'left' },
            ];

            // 內容資料
            const bodyRows = [];
            details.forEach((item) => {
                const row = [
                    '',
                    item.payoo,
                    item.nam,
                    _.find(attachmentTypes, ['key', item.filE_TYP])?.value,
                    item.foO_DAT ? moment(item.foO_DAT).format('YYYY-MM-DD') : '--',
                    item.foo || '--',
                    item.companyName || '--',
                    item.bsn || '--',
                    item.amt,
                    item.tax,
                    item.amt - item.tax,
                    item.cny,
                    item.rat || this.getCnyRat(item.cny),
                    this.get401StatusTxt(item),
                    item.note,
                ];
                bodyRows.push(row);
            });
            // 總計列
            const totalAmt = _.sumBy(details, (o) => o.amt * (o.rat || this.getCnyRat(o.cny)));
            const totalTax = _.sumBy(details, (o) => o.tax * (o.rat || this.getCnyRat(o.cny)));
            const totalNonTax = _.sumBy(details, (o) => (o.amt - o.tax) * (o.rat || this.getCnyRat(o.cny)));
            bodyRows.push(['', '', '總計(約當台幣)', '', '', '', '', '', totalAmt, totalTax, totalNonTax, '', '', '', '']);

            // 表頭資訊
            const headRows = [
                ...this.getQueryText(),
                { label: '單據總額總計(約當台幣)', value: totalAmt },
                { label: '稅額總計(約當台幣)', value: totalTax },
                { label: '未稅金額總計(約當台幣)', value: totalNonTax },
                { label: '製表日期', value: CD },
            ];

            return MyXLSX2.createSheet(title, headRows, bodyHeader, bodyRows);
        },

        getToBePaySheet(oriDetails, subTitle, status) {
            const details = _.filter(oriDetails, ['sigN_STS', status]);
            if (!details.length) return null;
            const title = `請款單 - ${subTitle}`;

            // 內容表頭
            const bodyHeader = [
                { text: '', width: 5, align: 'center' },
                { text: '單號', align: 'center' },
                { text: '摘要', width: 30, align: 'left' },
                { text: '請款單日期', align: 'center' },
                { text: '狀態', align: 'center' },
                { text: '專案編號', align: 'center' },
                { text: '專案名稱', width: 20, align: 'left' },
                { text: '類型', align: 'center' },
                { text: '申請日期', align: 'center' },
                { text: '申請人', align: 'center' },
                { text: '預計付款日', align: 'center' },
                { text: '請款金額', align: 'right', number: true },
                { text: '幣別', align: 'center' },
                { text: '匯率', width: 10, align: 'right' },
                { text: '收款戶名', align: 'center' },
                { text: '收款銀行', width: 30, align: 'center' },
                { text: '收款銀行代碼', width: 15, align: 'left' },
                { text: '收款分行代碼', width: 15, align: 'left' },
                { text: '收款銀行帳號', width: 15, align: 'left' },
                { text: '預計付款方式', align: 'center' },
            ];

            // 內容資料
            const bodyRows = [];
            details.forEach((item) => {
                const row = [
                    '',
                    item.payoo,
                    item.nam,
                    item.dat ? moment(item.dat).format('YYYY-MM-DD') : '--',
                    _.find(paymentStatus, ['key', item.sigN_STS])?.value,
                    item.poo || '--',
                    item.projectName || '--',
                    _.find(paymentType, ['key', item.typ])?.value,
                    item.crT_DAT ? moment(item.crT_DAT).format('YYYY-MM-DD') : '--',
                    item.creator,
                    item.pdat ? moment(item.pdat).format('YYYY-MM-DD') : '--',
                    item.amt,
                    item.cny,
                    this.getCnyRat(item.cny),
                    item.useR_PAY_WAY === 2 ? item.vdR_BNK_TPC : '',
                    item.useR_PAY_WAY === 2 ? item.bankName || '--' : '',
                    item.useR_PAY_WAY === 2 ? item.vdR_BNK_BOO || '--' : '',
                    item.useR_PAY_WAY === 2 ? this.getBnkDoo(item.vdR_BNK_DOO) || '--' : '',
                    item.useR_PAY_WAY === 2 ? item.vdR_BNK_ACC || '--' : '',
                    PAY_WAY_LIST[item.useR_PAY_WAY - 1],
                ];
                bodyRows.push(row);
            });
            // 總計列
            const totalAmt = _.sumBy(details, (o) => o.amt * this.getCnyRat(o.cny));
            bodyRows.push(['', '總計(約當台幣)', '', '', '', '', '', '', '', '', '', totalAmt, '', '', '', '', '', '', '', '']);

            // 表頭資訊
            const headRows = [...this.getQueryText(), { label: '請款金額總計(約當台幣)', value: totalAmt }, ...this.getTrimCnyStatistic(details), { label: '製表日期', value: CD }];

            return MyXLSX2.createSheet(title, headRows, bodyHeader, bodyRows);
        },

        getAfterPaySheetForAccounting(oriDetails, subTitle, status) {
            const details = _.filter(oriDetails, ['sigN_STS', status]);
            if (!details.length) return null;
            const title = `請款單 - ${subTitle}`;

            // 內容表頭
            const bodyHeader = [
                { text: '', width: 5, align: 'center' },
                { text: '單號', align: 'center' },
                { text: '摘要', width: 30, align: 'left' },
                { text: '請款單日期', align: 'center' },
                { text: '支出項目', width: 60, align: 'left' },
                { text: '立帳科目', width: 20, align: 'left' },
                { text: '沖帳科目', width: 20, align: 'left' },
                { text: '狀態', align: 'center' },
                { text: '專案編號', align: 'center' },
                { text: '專案名稱', width: 20, align: 'left' },
                { text: '類型', align: 'center' },
                { text: '申請日期', align: 'center' },
                { text: '申請人', align: 'center' },
                { text: '預計付款日期', align: 'center' },
                { text: '實際付款日期', align: 'center' },
                { text: '請款金額', align: 'right', number: true },
                { text: '幣別', align: 'center' },
                { text: '匯率', width: 10, align: 'right' },
                { text: '收款戶名', align: 'center' },
                { text: '收款銀行', width: 30, align: 'center' },
                { text: '收款銀行代碼', width: 15, align: 'left' },
                { text: '收款分行代碼', width: 15, align: 'left' },
                { text: '收款銀行帳號', width: 15, align: 'left' },
                { text: '實際付款方式', align: 'center' },
                { text: '勞務所得類別', width: 30, align: 'left' },
                { text: '代扣稅額', align: 'right', number: true },
                { text: '代扣二代健保', align: 'right', number: true },
                { text: '實付金額', align: 'right', number: true },
                { text: '付款帳戶簡稱', width: 30, align: 'center' },
                { text: '付款銀行', width: 30, align: 'center' },
            ];

            // 內容資料
            const bodyRows = [];
            details.forEach((item) => {
                const row = [
                    '',
                    item.payoo,
                    item.nam,
                    item.dat ? moment(item.dat).format('YYYY-MM-DD') : '--',
                    this.getHierarchyItemName(item.iteM_SNO, item.itemName),
                    item.accno ? `${item.accno} ${item.accnam || ''}` : '--',
                    item.clearanceAccno ? `${item.clearanceAccno} ${item.clearanceAccnoNam || ''}` : '--',
                    _.find(paymentStatus, ['key', item.sigN_STS])?.value,
                    item.poo || '--',
                    item.projectName || '--',
                    _.find(paymentType, ['key', item.typ])?.value,
                    item.crT_DAT ? moment(item.crT_DAT).format('YYYY-MM-DD') : '--',
                    item.creator,
                    item.pdat ? moment(item.pdat).format('YYYY-MM-DD') : '--',
                    item.paY_DAT ? moment(item.paY_DAT).format('YYYY-MM-DD') : '--',
                    item.amt,
                    item.cny,
                    item.paY_CNYRAT,
                    item.paY_WAY === 2 ? item.vdR_BNK_TPC : '',
                    item.paY_WAY === 2 ? item.bankName || '--' : '',
                    item.paY_WAY === 2 ? item.vdR_BNK_BOO || '--' : '',
                    item.paY_WAY === 2 ? this.getBnkDoo(item.vdR_BNK_DOO) || '--' : '',
                    item.paY_WAY === 2 ? item.vdR_BNK_ACC || '--' : '',
                    PAY_WAY_LIST[item.paY_WAY - 1],
                    item.taX_AMT || item.geN2_AMT ? getServiceTypeTxt(item.serviceType) : '--',
                    item.taX_AMT,
                    item.geN2_AMT,
                    item.amt * item.paY_CNYRAT - item.taX_AMT - item.geN2_AMT,
                    item.paY_BNK_TPC || '--',
                    item.paY_BNK_NAM || '--',
                ];
                bodyRows.push(row);
            });
            // 總計列
            const totalAmt = _.sumBy(details, (o) => o.amt * o.paY_CNYRAT);
            const totalTaxAmt = _.sumBy(details, (o) => o.taX_AMT);
            const totalGen2Amt = _.sumBy(details, (o) => o.geN2_AMT);
            const totalActualAmt = _.sumBy(details, (o) => o.amt * o.paY_CNYRAT - o.taX_AMT - o.geN2_AMT);
            bodyRows.push(['', '總計(約當台幣)', '', '', '', '', '', '', '', '', '', '', '', '', '', totalAmt, '', '', '', '', '', '', '', '', '', totalTaxAmt, totalGen2Amt, totalActualAmt, '', '']);

            // 表頭資訊
            const headRows = [...this.getQueryText(), { label: '請款金額總計(約當台幣)', value: totalAmt }, ...this.getTrimCnyStatistic(details), { label: '製表日期', value: CD }];

            return MyXLSX2.createSheet(title, headRows, bodyHeader, bodyRows);
        },

        getAfterPaySheet(oriDetails, subTitle, status) {
            const details = _.filter(oriDetails, ['sigN_STS', status]);
            if (!details.length) return null;
            const title = `請款單 - ${subTitle}`;

            // 內容表頭
            const bodyHeader = [
                { text: '', width: 5, align: 'center' },
                { text: '單號', align: 'center' },
                { text: '摘要', width: 30, align: 'left' },
                { text: '請款單日期', align: 'center' },
                { text: '支出項目', width: 60, align: 'left' },
                { text: '狀態', align: 'center' },
                { text: '專案編號', align: 'center' },
                { text: '專案名稱', width: 20, align: 'left' },
                { text: '類型', align: 'center' },
                { text: '申請日期', align: 'center' },
                { text: '申請人', align: 'center' },
                { text: '預計付款日期', align: 'center' },
                { text: '實際付款日期', align: 'center' },
                { text: '請款金額', align: 'right', number: true },
                { text: '幣別', align: 'center' },
                { text: '匯率', width: 10, align: 'right' },
                { text: '收款戶名', align: 'center' },
                { text: '收款銀行', width: 30, align: 'center' },
                { text: '收款銀行代碼', width: 15, align: 'left' },
                { text: '收款分行代碼', width: 15, align: 'left' },
                { text: '收款銀行帳號', width: 15, align: 'left' },
                { text: '實際付款方式', align: 'center' },
                { text: '勞務所得類別', width: 30, align: 'left' },
                { text: '代扣稅額', align: 'right', number: true },
                { text: '代扣二代健保', align: 'right', number: true },
                { text: '實付金額', align: 'right', number: true },
                { text: '付款帳戶簡稱', width: 30, align: 'center' },
                { text: '付款銀行', width: 30, align: 'center' },
            ];

            // 內容資料
            const bodyRows = [];
            details.forEach((item) => {
                const row = [
                    '',
                    item.payoo,
                    item.nam,
                    item.dat ? moment(item.dat).format('YYYY-MM-DD') : '--',
                    this.getHierarchyItemName(item.iteM_SNO, item.itemName),
                    _.find(paymentStatus, ['key', item.sigN_STS])?.value,
                    item.poo || '--',
                    item.projectName || '--',
                    _.find(paymentType, ['key', item.typ])?.value,
                    item.crT_DAT ? moment(item.crT_DAT).format('YYYY-MM-DD') : '--',
                    item.creator,
                    item.pdat ? moment(item.pdat).format('YYYY-MM-DD') : '--',
                    item.paY_DAT ? moment(item.paY_DAT).format('YYYY-MM-DD') : '--',
                    item.amt,
                    item.cny,
                    item.paY_CNYRAT,
                    item.paY_WAY === 2 ? item.vdR_BNK_TPC : '',
                    item.paY_WAY === 2 ? item.bankName || '--' : '',
                    item.paY_WAY === 2 ? item.vdR_BNK_BOO || '--' : '',
                    item.paY_WAY === 2 ? this.getBnkDoo(item.vdR_BNK_DOO) || '--' : '',
                    item.paY_WAY === 2 ? item.vdR_BNK_ACC || '--' : '',
                    PAY_WAY_LIST[item.paY_WAY - 1],
                    item.taX_AMT || item.geN2_AMT ? getServiceTypeTxt(item.serviceType) : '--',
                    item.taX_AMT,
                    item.geN2_AMT,
                    item.amt * item.paY_CNYRAT - item.taX_AMT - item.geN2_AMT,
                    item.paY_BNK_TPC || '--',
                    item.paY_BNK_NAM || '--',
                ];
                bodyRows.push(row);
            });
            // 總計列
            const totalAmt = _.sumBy(details, (o) => o.amt * o.paY_CNYRAT);
            const totalTaxAmt = _.sumBy(details, (o) => o.taX_AMT);
            const totalGen2Amt = _.sumBy(details, (o) => o.geN2_AMT);
            const totalActualAmt = _.sumBy(details, (o) => o.amt * o.paY_CNYRAT - o.taX_AMT - o.geN2_AMT);
            bodyRows.push(['', '總計(約當台幣)', '', '', '', '', '', '', '', '', '', '', '', totalAmt, '', '', '', '', '', '', '', '', '', totalTaxAmt, totalGen2Amt, totalActualAmt, '', '']);

            // 表頭資訊
            const headRows = [...this.getQueryText(), { label: '請款金額總計(約當台幣)', value: totalAmt }, ...this.getTrimCnyStatistic(details), { label: '製表日期', value: CD }];

            return MyXLSX2.createSheet(title, headRows, bodyHeader, bodyRows);
        },

        getCnyRat(cny) {
            const cnyOption = this.$store.getters['cny/cnyOptions'].find((x) => x.cny === cny);
            if (cnyOption) return cnyOption.rat;
            return 1;
        },
        getBnkDoo(doo) {
            if (doo === '700') return '0021';
            return doo ? doo.substring(3) : '';
        },

        async getExportData(params) {
            const PageSize = 1000;
            let PageNum = 1;
            const { query, resetQuery } = this.getManualQuery(this.prevQuery);
            const url = `PaymentManagenmentPage/QueryPayment${query}`;

            const { data } = await this.$api({
                url,
                method: 'GET',
                params: {
                    ...params,
                    ...resetQuery,
                    PageNum: 1,
                    PageSize,
                },
            });

            // 足夠的PageSize
            if (PageSize > data.totalNum) {
                return data.items;
            }

            const currentList = [...data.items];
            for (let i = 0; i < Math.ceil(data.totalNum / PageSize) - 1; i += 1) {
                PageNum += 1;
                // eslint-disable-next-line no-await-in-loop
                const resp = await this.$api({
                    url,
                    method: 'GET',
                    params: { ...params, PageNum, PageSize },
                });
                currentList.push(...resp.data.items);
            }
            return currentList;
        },

        async getExportDataBySelected() {
            const details = [];
            for (let i = 0; i < this.selectedDatas.length; i += 1) {
                const { sno } = this.selectedDatas[i];
                // eslint-disable-next-line no-await-in-loop
                const resp = await this.$api({
                    url: '/PaymentManagenmentPage/GetPaymentInfo',
                    method: 'GET',
                    params: { Sno: sno },
                });
                if (resp.data.item) details.push(resp.data.item);
            }
            return details;
        },

        getQueryText() {
            const LIST = [
                { text: '關鍵字', field: 'PayooOrNote' },
                {
                    text: '請款類型',
                    field: 'PaymentType',
                    options: this.paymentTypeFDatas,
                    optionFind: 'value',
                    optionField: 'name',
                },
                { text: '請款單日期', field: 'PaymentDate', isDate: true },
                {
                    text: '專案',
                    field: 'ProjectId',
                    options: this.projectList,
                    optionFind: 'sno',
                    optionField: 'nam',
                },
                {
                    text: '特定費用項目',
                    field: 'SpecialProjectId',
                    options: this.spProjectList,
                    optionFind: 'sno',
                    optionField: 'nam',
                },
                { text: '收支項目', field: 'ITEM_SNO', textOnly: true },
                {
                    text: '申請人',
                    field: 'Creator',
                    options: this.creatorOptions,
                    optionFind: 'sno',
                    optionField: 'nam',
                },
                { text: '付款對象戶名', field: 'PayeeName' },
                { text: '金額下限', field: 'AMT_Min' },
                { text: '金額上限', field: 'AMT_Max' },
                {
                    text: '付款帳戶',
                    field: 'PAY_BNK_SNO',
                    options: this.bankAccountOptions,
                    optionFind: 'sno',
                    optionField: 'tpc',
                },
                { text: '幣別', field: 'cny' },
                {
                    text: '預計付款方式',
                    field: 'USER_PAY_WAY',
                    options: this.payWayList,
                    optionFind: 'value',
                    optionField: 'label',
                },
                {
                    text: '實際付款方式',
                    field: 'PAY_WAY',
                    options: this.payWayList,
                    optionFind: 'value',
                    optionField: 'label',
                },
                { text: '預計付款日', field: 'ExpectePayDate', isDate: true },
                { text: '實際付款日', field: 'ActualPayDate', isDate: true },
            ];
            const RETURN = [];

            LIST.forEach((item) => {
                const VALUE = this.prevQuery[item.field];
                if ((!Array.isArray(VALUE) && VALUE) || (Array.isArray(VALUE) && VALUE.length)) {
                    const OPTIONS = item.options;
                    if (item.textOnly) {
                        RETURN.push({
                            label: item.text,
                            value: `${VALUE.length === 1 ? '單選' : `複選(${VALUE.length})`}`,
                        });
                    } else if (Array.isArray(VALUE)) {
                        if (item.isDate) {
                            const sd = moment(VALUE[0]).format('YYYY-MM-DD');
                            const ed = moment(VALUE[1]).format('YYYY-MM-DD');
                            RETURN.push({
                                label: item.text,
                                value: `${sd} ~ ${ed}`,
                            });
                        } else if (OPTIONS) {
                            const LIST_TEXT = _.map(VALUE, (o) => _.find(OPTIONS, [item.optionFind, o])[item.optionField]);
                            RETURN.push({
                                label: item.text,
                                value: LIST_TEXT.join(', '),
                            });
                        } else {
                            RETURN.push({
                                label: item.text,
                                value: VALUE.join(', '),
                            });
                        }
                    } else if (OPTIONS) {
                        const FOUND = _.find(OPTIONS, [item.optionFind, VALUE])[item.optionField];
                        RETURN.push({ label: item.text, value: FOUND });
                    } else {
                        RETURN.push({
                            label: item.text,
                            value: VALUE,
                        });
                    }
                }
            });

            return RETURN.length ? RETURN : [{ label: '查詢條件', value: '不限' }];
        },
        getTrimCnyStatistic(details) {
            const cnyOptions = this.$store.getters['cny/cnyOptions'];
            const cnyStatisticList = [];
            cnyOptions.forEach((item, i) => {
                const amt = _.chain(details)
                    .filter(['cny', item.cny])
                    .sumBy('amt')
                    .value();
                if (amt) {
                    cnyStatisticList.push({
                        cny: item.cny,
                        label: !i ? '各幣別總額' : '',
                        value: `${item.cny}: ${amt.toLocaleString('en-US')}`,
                    });
                }
            });
            if (cnyStatisticList.length === 1 && _.first(cnyStatisticList).cny === 'TWD') return [];
            return cnyStatisticList;
        },

        get401StatusTxt(data) {
            switch (data.declareStatus) {
                case 0:
                    return '可扣抵申報';
                case 2:
                    return '不申報';
                default:
                    return `已申報${this.getPeriodText(data.prefiX_YER, data.prefiX_MONTH)}`;
            }
        },
        getPeriodText(year, month) {
            const monthList = ['1~2月', '3~4月', '5~6月', '7~8月', '9~10月', '11~12月'];
            if (year > 1911 && month >= 0 && month < 12) {
                return `${year - 1911}年 ${monthList[month - 1]}`;
            }
            return '';
        },
        /**
         * 根據支出項目的 SNO 組合出三階層名稱（例如：營業其他支出 / 離職人員費用 / 資遣費）
         * @param {Number} itemSno 支出項目編號
         * @param {String} fallbackName 備用名稱（未對應到時使用）
         * @returns {String} 三階層名稱
         */
        getHierarchyItemName(itemSno, fallbackName) {
            if (!itemSno) return fallbackName || '--';
            const statementOptionsForUi = this.$store.getters['statement/statementUiOptions'];
            if (!statementOptionsForUi) return fallbackName || '--';

            const hierarchy = [null, null, null];
            const types = [
                { key: 'payoutSettings', name: '營業支出' },
                { key: 'invoiceSettings', name: '營業收入' },
                { key: 'cInSettings', name: '營業其他收入' },
                { key: 'cInElseSettings', name: '財務資產收入' },
                { key: 'cOutSettings', name: '營業其他支出' },
                { key: 'cOutElseSettings', name: '財務資產支出' },
            ];

            let found = false;
            for (let t = 0; t < types.length; t += 1) {
                const options = statementOptionsForUi[types[t].key];
                if (!options) continue;
                for (let i = 0; i < options.length; i += 1) {
                    const lv1Item = options[i];
                    if (!lv1Item.childSettings) continue;
                    for (let j = 0; j < lv1Item.childSettings.length; j += 1) {
                        const lv2Item = lv1Item.childSettings[j];
                        if (lv2Item.sno === itemSno) {
                            hierarchy[0] = types[t].name;
                            hierarchy[1] = lv1Item.iteM_NAM;
                            hierarchy[2] = lv2Item.iteM_NAM;
                            found = true;
                            break;
                        }
                    }
                    if (found) break;
                }
                if (found) break;
            }

            if (!found) return fallbackName || '--';
            return hierarchy.join(' / ');
        },
    },
};
